import { render, staticRenderFns } from "./UserProjectsOverview.vue?vue&type=template&id=03d9d80a"
import script from "./UserProjectsOverview.vue?vue&type=script&lang=js"
export * from "./UserProjectsOverview.vue?vue&type=script&lang=js"
import style0 from "./UserProjectsOverview.vue?vue&type=style&index=0&id=03d9d80a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports